module.exports = __webpack_public_path__ + "img/P150T_weapon_137.297b0dfa.png";